if(!customElements.get('product-country')){
    class ProductCountry extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            var productLink = this.dataset.productLink;
            productLink = productLink.split('?');
            productLink = productLink[0];
            this.productLink = `${productLink}`;

            fetch(this.productLink)
            .then(res => {
                if(!res.ok){
                    var error = new Error(res.status);
                    throw error;
                }

                return res.text();
            })
            .then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
                const productInfo = resultsMarkup.querySelector('product-info');

                if (productInfo) {
                    const country = productInfo.querySelector('.country');
                    if (country) {
                        const coolDelivery = country.querySelector('.country__cool-delivery');
                        if (coolDelivery) {
                            const slot = this.parentElement ? this.parentElement.querySelector('.product-card__cool-delivery-slot') : null;
                            if (slot) {
                                slot.innerHTML = coolDelivery.outerHTML;
                            }
                            coolDelivery.remove();
                        }

                        this.innerHTML = country.innerHTML;
                    }
                }
            })
        }
    }

    customElements.define('product-country', ProductCountry);
}